/**
 * Column header row. Above sm: Name · Date modified · File size.
 * Under sm: collapse to just Name (date/size move into a stacked meta line per row).
 */
export function ColumnHeaders() {
  return (
    <div className="flex items-center border-b border-surface-border px-gutter py-2 text-meta font-medium uppercase tracking-wide text-text-muted">
      <div className="min-w-0 flex-1">Name</div>
      <div className="hidden w-40 shrink-0 sm:block">Date modified</div>
      <div className="hidden w-24 shrink-0 text-right sm:block">File size</div>
      <div className="w-8 shrink-0" aria-hidden="true" />
    </div>
  );
}
